<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2 class="page-title-h2">
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>فعالیت های روزانه
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="" data-card-height="150" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
                <div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
                <div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
                <div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div v-if="true">
                <div class="card card-style mb-2">
                    <div class="row m-0 p-3">
                        <div class="col-6 pr-0 pl-1">
                            <div class="input-style input-style-2 input-required has-icon m-0">
                                <i class="input-icon fa fa-filter color-orange-dark"></i>
                                <em><i class="fa fa-angle-down"></i></em>
                                <select class="form-control" v-model="filterId" autocomplete="off" @change="filterList">
                                    <option value="0">فعالیت های روزانه من</option>
                                    <option value="1">فعالیت های روزانه تیم من</option>

                                </select>

                            </div>
                        </div>
                        <div class="col-6 p-0">
                            <div class="search-box search-color bg-magenta1-light rounded-sm">
                                <i class="fa fa-search"></i>
                                <input type="text" class="border-0 pr-4" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                            </div>
                        </div>
                    </div>
                </div>
                <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

                <div class="card card-style mb-2" v-for="task in OtherWorkList" :key="task.otherWorkId">

                    <div class="py-2 px-3" :id="'otherWork-'+task.otherWorkId">
                        <button data-toggle="collapse" type="button" :data-target="'#collapse-'+task.otherWorkId" class="no-effect collapsed accordion-btn pr-0" aria-expanded="false">
                            <span class="d-flex justify-content-between align-items-center">
                                <span class="d-flex flex-column">
                                    <b class="font-16 text-dark">{{task.subject}}</b>
                                    <span class="font-14 text-muted">{{task.workDate}}</span>
                                </span>
                                <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                            </span>
                        </button>
                    </div>

                    <div class="collapse border-t" :id="'collapse-'+task.otherWorkId" @click.prevent="openDetails(task.otherWorkId)">
                        <div class="d-flex justify-content-between py-2 pr-4 pl-3">
                            <div class="d-flex justify-content-between" style="width:80%">
                                <div>
                                    <i class="fa fa-hashtag color-blue2-dark ml-3"></i>
                                    <span class="text-muted">{{task.workNo}}</span>
                                </div>
                                <div>
                                    <i class="fa fa-user color-green2-light ml-3"></i>
                                    <span class="font-weight-bold">{{task.userTitle}}</span>
                                </div>

                            </div>

                            <span class="text-left" @click.stop="showMenu(task)" style="width:20%"><i class="fa fa-ellipsis-v font-14"></i></span>
                        </div>
                        <div v-if="task.workUsedTime!==''" class="d-flex justify-content-between pr-4 pb-2" style="width:80%">
                            <div>
                                <span class="text-muted">زمان استفاده شده: {{task.workUsedTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && NoMoreData==false && OtherWorkList.length>0 && OtherWorkList.length%20==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info" @click="getNextPageForOtherWorkList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="OtherWorkList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">فعالیتی یافت نشد.</p>
                    </div>
                </div>
            </div>


            <div class="card card-style" v-else>
                <div class="content">
                    <h4 class="mb-0 text-center">تصاویر بخش فعالیت ها</h4>
                </div>
                <div class="divider mb-0"></div>
                <div class="gallery-view-controls d-flex justify-content-center">
                    <a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
                    <a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
                    <div class="clearfix"></div>
                </div>
                <div class="content my-n1">
                    <div class="gallery-views gallery-view-2">
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-1-L.jpg" title="لیست فعالیت های من" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-1-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست فعالیت های من</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-2-L.jpg" title="لیست فعالیت های تیم من" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-2-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست فعالیت های تیم من</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-3-L.jpg" title="ثبت فعالیت های روزانه" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-3-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ثبت فعالیت های روزانه</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-4-L.jpg" title="انتخاب نوع فعالیت" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-4-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">انتخاب نوع فعالیت</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-5-L.jpg" title="ضمیمه کردن فایل به فعالیت" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-5-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-5-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ضمیمه کردن فایل به فعالیت</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-6-L.jpg" title="ضبط مستقیم فایل صوتی" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-6-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-6-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class=" color-theme">ضبط مستقیم فایل صوتی</h4>
                            </div>
                        </a>
                    </div>
                </div>

                <a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>تهیه اشتراک اپلیکشن</a>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-if="pageLoaded==true && isFreeRegist!==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/CreateOtherWork" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditOtherWork', params: { otherWorkId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="AddPin" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-thumbtack color-blue2-light float-right font-14"></i>نشان کردن</span><i class="fa fa-angle-left"></i></button>

                    <button @click="deleteOtherWork" class="d-flex justify-content-between align-items-center bg-white p-0"><span><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>

        <Help-Menu title="راهنمای ثبت فعالیت" keyEn="OtherWorkList"></Help-Menu>
        <!--<div id="createOtherWorkHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای ثبت فعالیت</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو  <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>

                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OtherWork.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OtherWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
                                <i class="far font-14 fa-check-circle color-red2-dark"></i>
                                <span class="font-14">راهنمای ثبت فعالیت</span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-1" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        <my-tour></my-tour>
    </div>



</template>

<script>
    import myTour from '../Tours/OtherWorkListTour.vue'
    import VueSimpleAlert from "vue3-simple-alert";
    import calendarFilter from '../Components/CalendarFilter.vue';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            myTour,
            "Help-Menu": HelpMenu,
            "calendar-filter": calendarFilter,
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedWorkId: 0,
                selectedTitle: null,
                pageLoaded: false,
                date: null

            };
        },
        computed: {
            OtherWorkList() {
                return this.$store.getters.GetOtherWorkList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetOtherWorkNoMoreData;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            UpdateOtherWorkList() {
                return this.$store.getters.GetUpdateOtherWorkList;
            },
        },

        created() {
            console.log(this.NoMoreData);

            this.$store.dispatch("GetOtherWorkListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;

            },
            showMenu(item) {
                this.selectedWorkId = item.otherWorkId;
                this.selectedTitle = item.subject;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetOtherWorkListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            deleteOtherWork() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این فعالیت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("OtherWork/Delete?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data;
                            if (res.includes("حذف شد")) {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.filterList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            selectDate(d) {
                this.date = d;
                this.page = 0;
                this.getNextPageForOtherWorkList();
            },
            openDetails(otherWorkId) {
                this.$router.push({ name: 'EditOtherWork', params: { otherWorkId: otherWorkId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForOtherWorkList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetOtherWorkListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    date: this.date
                });
            },
            AddPin() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به نشان کردن این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {

                    this.$store.dispatch("AddPin", {
                        baseDocId: 16,
                        docId: this.selectedWorkId,
                        description: this.selectedTitle
                    });
                });

            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateOtherWorkList == true) {
                this.page = 0;
                this.getNextPageForOtherWorkList();
            }
            // this.getNextPageForOtherWorkList();
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
